import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import TStore from '../../../../types/store';
import { TQuestionnaireDetail } from '../../../../types/questionnaires';
import { FormattedMessage } from 'react-intl';
import { QuestionnaireDetailSC } from './questionnaires.styled';
import QuestionnaireAnswer from './questionnaire-answer';
import { memberApi } from '../../../../lib/api';
import { getIcon } from './questionnaire-icons';
import { getDateFormat } from '../../../../helpers/utils-helpers';

type TCountry = {
  name: string;
  code: string;
};

const QuestionnaierDetail: React.FC = () => {
  const intl = useIntl();
  const [countries, setCountries] = useState<TCountry[]>([]);
  const questionnaireDetail: TQuestionnaireDetail | null = useSelector(
    (store: TStore) => store.questionnaires.questionnaireDetail,
  );

  useEffect(() => {
    const lang = 'sk';
    memberApi.getCountries(lang).then((res: any) => {
      setCountries(res.data.data);
    });
  }, [setCountries]);

  if (questionnaireDetail === null) {
    return null;
  }

  const { questionnaire, data, createdAt } = questionnaireDetail;

  return (
    <QuestionnaireDetailSC>
      <h3>{intl.formatMessage({ id: `questionnaire:${questionnaire.name}` })}</h3>
      <div className="qd-subtitle">
        <FormattedMessage
          id="questionnaire.prepared_at"
          values={{ date: moment(createdAt).format(getDateFormat()) }}
        />
      </div>
      {data.map(({ id, question, answer }) => (
        <QuestionnaireAnswer
          key={id}
          icon={getIcon(id)}
          title={question}
          answers={answer}
          countries={countries}
        />
      ))}
    </QuestionnaireDetailSC>
  );
};

export default QuestionnaierDetail;
